"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// For more details on the LaunchDarkly SDK, see
// https://docs.launchdarkly.com/sdk/client-side/javascript
var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
var client_feature_flag_service_1 = require("./client-feature-flag-service");
// FUTURE: support mechanism for Streaming Updates using a 'change' listener
var LaunchDarklyClientProvider = /** @class */ (function (_super) {
    __extends(LaunchDarklyClientProvider, _super);
    function LaunchDarklyClientProvider(clientSideId) {
        var _this = _super.call(this) || this;
        _this.initialized = false;
        _this.clientSideId = clientSideId;
        return _this;
    }
    LaunchDarklyClientProvider.prototype.initialize = function (featureFlagScope) {
        return __awaiter(this, void 0, void 0, function () {
            var leasingTeamId, custom, user;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Ensure we only initialize once:
                        if (this.initialized) {
                            return [2 /*return*/];
                        }
                        leasingTeamId = featureFlagScope.getLeasingTeamId();
                        custom = featureFlagScope.getCustom();
                        user = {
                            key: "leasing-team-" + leasingTeamId,
                            custom: custom,
                        };
                        this.client = launchdarkly_js_client_sdk_1.initialize(this.clientSideId, user);
                        // NOTE: the LD JS client is not an event emitter, as docs recommend registering event listeners.
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.client.on('ready', function () {
                                    _this.initialized = true;
                                    resolve();
                                });
                                _this.client.on('error', function () {
                                    reject();
                                });
                            })];
                    case 1:
                        // NOTE: the LD JS client is not an event emitter, as docs recommend registering event listeners.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Note: this function is async, even though LaunchDarkly's variation() call is synchronous, as
    // this allows us maximum flexibility to swap out the underlying flag provider with one that
    // asynchronously requests values
    LaunchDarklyClientProvider.prototype.get = function (featureKey, defaultValue) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.variation(featureKey, defaultValue)];
            });
        });
    };
    return LaunchDarklyClientProvider;
}(client_feature_flag_service_1.ClientFeatureFlagProvider));
exports.default = LaunchDarklyClientProvider;
